import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";

class Conversation extends Component {

    render() {
        return (
            <div className="col-lg-12" style={{ marginLeft: "20px" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <ToastContainer className="Toast-at-center" />

                <div class="row mt-4 mb-4">
                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Conversations<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.props.value.noOfYesterdayChat}{this.props.value.yesterdayChatScaleType}<br />
                            <div style={{ fontSize: "10px" }}>Yesterday</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Conversations<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.props.value.noOfLast7DayChat}{this.props.value.last7DayChatScaleType}<br />
                            <div style={{ fontSize: "10px" }}>Last 7 Days</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Conversations<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.props.value.noOfLast30DayChat}{this.props.value.last30DayChatScaleType}<br />
                            <div style={{ fontSize: "10px" }}>Last 30 Days</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Conversation;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/statistics/conversationStat/Conversations.js